import { render, staticRenderFns } from "./Calculadora.vue?vue&type=template&id=06fd1dd5&scoped=true&"
import script from "./Calculadora.vue?vue&type=script&lang=js&"
export * from "./Calculadora.vue?vue&type=script&lang=js&"
import style0 from "./Calculadora.vue?vue&type=style&index=0&id=06fd1dd5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06fd1dd5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Jenkins\\work\\workspace\\Tecnologia\\Source\\Wes\\WebApp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06fd1dd5')) {
      api.createRecord('06fd1dd5', component.options)
    } else {
      api.reload('06fd1dd5', component.options)
    }
    module.hot.accept("./Calculadora.vue?vue&type=template&id=06fd1dd5&scoped=true&", function () {
      api.rerender('06fd1dd5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "content/components/example/Calculadora.vue"
export default component.exports